import { MonitorSmartphone } from 'lucide-react';
import type { ActionModalProps } from '../types';
import { NotLinkedActionModal } from './NotLinkedActionModal';

export function DevicesModal({ pharmacy, onClose }: ActionModalProps) {
  return (
    <NotLinkedActionModal
      title="Manage Devices"
      description={pharmacy.name}
      icon={<MonitorSmartphone size={18} aria-hidden="true" />}
      size="lg"
      notice="POS devices are registered in the production POS cloud. Central Admin does not list, link, sync or unlink devices."
      known={[{ label: 'Device Setup (onboarding)', value: pharmacy.profile.deviceSetupMode === 'connect_later' ? 'Connect later' : 'Link existing device' }]}
      notLinked={['Devices', 'Online Devices', 'Last Seen']}
      actions={['Link Device']}
      managePermission="device.manage"
      onClose={onClose}
    />
  );
}
